// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0571674c","455":"36101317","977":"7b64b421"}[chunkId] + ".chunk.js";
};